module.exports = __webpack_public_path__ + "img/logo-nuked-with-text.1ff7232c.svg";